import './reviews.scss';
import { FC, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import ReviewOverview from './reviewOverview/ReviewOverview';
import { EmptyStateOptions, IShopReviews, IStore2 } from 'types';
import ReviewRow from '../reviewRow/ReviewRow';
import { Span } from 'components/helpers';
import { translations } from 'translations/en';
import InfiniteScroller from 'components/inifniteScroller/InfiniteScroller';
import { EmptyState } from 'components/emptyState';
import { getShopInitialReviews } from 'store/shop/ShopActions';
import ReviewsShopSkeleton from '../skeletons/ReviewsShopSkeleton';

const Reviews: FC<IShopReviews> = ({ reviews, avg, totalReviews, getInitialReviews }) => {
  useEffect(() => {
    if (!reviews) {
      getInitialReviews();
    }
  }, []);

  const renderReviews = useCallback(() => {
    return reviews?.list.map((review) => (
      <ReviewRow
        key={review.id}
        id={review.id}
        name={review.name}
        value={review.value}
        avatar={review.avatar}
        title={review.title}
        text={review.text}
        date={review.date}
        images={review.images}
      />
    ));
  }, [reviews?.list]);

  if (!reviews) {
    return <ReviewsShopSkeleton />;
  }

  const { totalRates } = reviews;

  return (
    <div className="shop-page-content">
      <div className="shop-page-information reviews">
        {!!avg && (
          <div className="side-bar">
            <div className="section">
              <div className="section-content">
                <ReviewOverview avg={avg} totalReviews={totalReviews} totalRates={totalRates} />
              </div>
            </div>
          </div>
        )}
        <div className="inner-preview">
          <div className="section">
            <Span text={translations.COMMON.REVIEWS} className="title" />
            <div className="reviews-list">
              <InfiniteScroller
                list={reviews.list}
                emptyState={<EmptyState type={EmptyStateOptions.ShopReviews} />}
                totalCount={totalReviews}
                scrollableTarget="shop-page"
                loadMore={() => {}}
                hasMore={reviews.hasMore}
              >
                {renderReviews()}
              </InfiniteScroller>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStore2) => {
  const { reviews, details } = state.shop;

  const avg = details?.averageRating || 0;

  const totalReviews = details?.totalReviews || 0;

  return {
    reviews,
    avg,
    totalReviews,
  };
};

const mapDispatchToProps = {
  getInitialReviews: getShopInitialReviews,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reviews);
